"use client";

import Honeybadger from "@honeybadger-io/js";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function RouteError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		Honeybadger.notify(error);
	}, [error]);

	return (
		<div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4 text-center">
			<h2 className="text-2xl font-semibold">Something went wrong</h2>
			<p className="text-muted-foreground max-w-md">
				An unexpected error occurred. Please try again.
			</p>
			<Button onClick={reset}>Try again</Button>
		</div>
	);
}
